import React from 'react';
import { EmptyState } from '../common';
import { Box, Button, Typography } from '../ui';
import { BookmarkIcon } from '../icons';

interface StandardLessonsSectionProps {
  lessonsEmpty: boolean;
  canEdit: boolean;
  lessonSidebar: React.ReactNode;
  shouldShowLessonViewer: boolean;
  hasSelectedLesson: boolean;
  selectedLessonLocked: boolean;
  lockedLessonPanel: React.ReactNode;
  lessonViewer: React.ReactNode;
  isDraft?: boolean;
  isAuthenticated: boolean;
  onEnroll: () => void;
  onSignIn: () => void;
}

const StandardLessonsSection: React.FC<StandardLessonsSectionProps> = ({
  lessonsEmpty,
  canEdit,
  lessonSidebar,
  shouldShowLessonViewer,
  hasSelectedLesson,
  selectedLessonLocked,
  lockedLessonPanel,
  lessonViewer,
  isDraft,
  isAuthenticated,
  onEnroll,
  onSignIn,
}) => {
  if (lessonsEmpty) {
    return (
      <EmptyState
        icon={<BookmarkIcon sx={{ fontSize: 100, color: 'grey.400' }} />}
        title="No lessons have been added yet"
        subtitle={canEdit ? 'Click the Add button below to create your first lesson' : 'This course has no lessons yet'}
      />
    );
  }

  return (
    <>
      {/* Left side: Lesson List Sidebar (always shown) */}
      {lessonSidebar}

      {/* Right side: Lesson Viewer or Enrollment Gate */}
      {shouldShowLessonViewer && hasSelectedLesson && selectedLessonLocked ? (
        lockedLessonPanel
      ) : shouldShowLessonViewer && hasSelectedLesson ? (
        lessonViewer
      ) : (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: 6,
            borderRadius: '12px',
            border: 'solid 1px rgb(228, 228, 228)',
            bgcolor: 'grey.50',
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {isDraft ? 'Course in draft' : 'Start learning'}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'center', maxWidth: 500 }}>
            {isDraft
              ? 'This course is in draft mode and not yet available.'
              : isAuthenticated
                ? 'Enroll to unlock the full curriculum and track your progress.'
                : 'Sign in and enroll to unlock the full curriculum.'}
          </Typography>
          {!isDraft && (
            isAuthenticated ? (
              <Button variant="contained" color="primary" onClick={onEnroll} sx={{ minWidth: 140 }}>
                Enroll
              </Button>
            ) : (
              <Button variant="contained" color="primary" onClick={onSignIn} sx={{ minWidth: 140 }}>
                Sign In
              </Button>
            )
          )}
        </Box>
      )}
    </>
  );
};

export default StandardLessonsSection;
